import React from "react";
import { NavLink } from "react-router-dom";

import logo_grey from "../../assets/img/logo_grey.svg";

import "./Footer.scss";

const Footer = (props) => {
  return (
    <footer className="d-print-none">
      <div className="constrainer">
        <div className="container py-4">
          <div className="row align-items-center">
            <div className="col-md-8">
              <nav>
                <ul className="footer-links my-2">
                  <li>
                    <NavLink exact to="/">
                      Home
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/donations">Donations</NavLink>
                  </li>
                  <li>
                    <NavLink to="/help">Help</NavLink>
                  </li>
                  <li>
                    <NavLink to="/about">About</NavLink>
                  </li>
                  <li>
                    <NavLink to="/licence">Licence/Copyright</NavLink>
                  </li>
                  <li>
                    <NavLink to="/terms">Terms/Privacy</NavLink>
                  </li>
                  <li>
                    <a href="https://blog.keadatabase.nz">Blog</a>
                  </li>
                </ul>
              </nav>
            </div>
            <div className="col-md-4">
              <div className="footer-attribution my-2">
                <div className="d-inline-block text-right">
                  <img src={logo_grey} alt="Kea Database" className="logo" />
                  <p className="version">{process.env.REACT_APP_VERSION}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
